import script from "./DivisionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DivisionForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__